import { useEffect, useState } from 'react'

import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet'
import Loader from 'react-loaders'

import AnimatedLetters from '../AnimatedLetters'
import './index.scss'

const Contact = () => {
  const [letterClass, setLetterClass] = useState('text-animate')
  const contactArray = 'Contact Me'.split('')

  useEffect(() => {
    setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
  }, [])

  // Email obfuscation to protect from spam bots
  const emailParts = {
    user: 'touheed',
    domain: 'gmail',
    tld: 'com',
    numbers: '93'
  }
  const email = `${emailParts.user}.khan.${emailParts.numbers}@${emailParts.domain}.${emailParts.tld}`

  return (
    <>
      <div className="container contact-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={contactArray}
              idx={15}
            />
          </h1>
          <p>
            I'm open to new opportunities and collaborations! If you're looking
            for someone who can bring fresh ideas and deliver impactful results,
            let's get in touch!
          </p>

          <div className="contact-info">
            <div className="contact-links">
              <div className="social-row">
                <a
                  href="https://www.linkedin.com/in/touheedkhan/"
                  target="_blank"
                  rel="noreferrer"
                  className="contact-link-item"
                >
                  <FontAwesomeIcon icon={faLinkedin} />
                  <span>LinkedIn</span>
                </a>
                <a
                  href="https://github.com/touheedk"
                  target="_blank"
                  rel="noreferrer"
                  className="contact-link-item"
                >
                  <FontAwesomeIcon icon={faGithub} />
                  <span>GitHub</span>
                </a>
              </div>
              <a
                href={`mailto:${email}`}
                className="contact-link-item"
              >
                <FontAwesomeIcon icon={faEnvelope} className="email-icon" />
                <span className="email-text">{email}</span>
              </a>
            </div>
          </div>

          {/* Contact form commented out for now */}
          {/* <div className="contact-form">
            <form ref={form} onSubmit={sendEmail}>
              <ul>
                <li className="half">
                  <input placeholder="Name" type="text" name="name" required />
                </li>
                <li className="half">
                  <input
                    placeholder="Email"
                    type="email"
                    name="email"
                    required
                  />
                </li>
                <li>
                  <input
                    placeholder="Subject"
                    type="text"
                    name="subject"
                    required
                  />
                </li>
                <li>
                  <textarea
                    placeholder="Message"
                    name="message"
                    required
                  ></textarea>
                </li>
                <li>
                  <button
                    type="submit"
                    className="flat-button"
                    disabled={loading}
                  >
                    {loading ? <ClipLoader color="#fff" size={20} /> : 'SEND'}
                  </button>
                </li>
              </ul>
              <ToastContainer />
            </form>
          </div> */}
        </div>
        <div className="map-wrap">
          <div className="info-map">
            <div className="info-map-content">
              <div className="info-name">Touheed Khan</div>
              <div className="info-location">
                <div className="location-line">Mumbai</div>
                <div className="location-line">Maharashtra, India</div>
              </div>
            </div>
          </div>
          <MapContainer center={[19.2307, 72.8567]} zoom={13}>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <Marker position={[19.2307, 72.8567]}>
              <Popup>
                Touheed lives here, come over for a cup of coffee :{')'}
              </Popup>
            </Marker>
          </MapContainer>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default Contact
